export const customFilter = (value: string | number | null, query: string | number | null) => {
  if (value === null || query === null) return -1;

  return value
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLocaleLowerCase()
    .indexOf(
      query
        .toString()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLocaleLowerCase(),
    );
};

export const formatCurrency = ({
  value,
  currencyCode,
  noDigits = false,
  sign = false,
  locale = "en",
}: {
  value: number;
  currencyCode: string;
  noDigits?: boolean;
  sign?: boolean;
  locale?: string;
}) => {
  return Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyCode,
    currencyDisplay: "narrowSymbol",
    minimumFractionDigits: noDigits ? 0 : undefined,
    maximumFractionDigits: noDigits ? 0 : undefined,
    signDisplay: sign ? "always" : undefined,
  }).format(value);
};
